export class ReliabilityExclusionPnPostModel {
  public Pn?: string;
  public ExcludeFailOnFit?: boolean;
  public ExcludePrematureFailure?: boolean;
  public ExcludeRogueUnit?: boolean;
}

export class ReliabilityExclusionPnPutModel {
  public Id?: number;
  public Pn?: string;
  public PnDescription?: string;
  public ExcludeFailOnFit?: boolean;
  public ExcludePrematureFailure?: boolean;
  public ExcludeRogueUnit?: boolean;
}
